import React, { useState } from 'react'
import { Box, Button, Card, CardContent, Typography, Grid, TextField, Paper } from '@mui/material'
import axios from "axios";

export default function PropertyTaxApplicationPortal() {
    const [file, setFile] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === "application/pdf") {
            const url = URL.createObjectURL(file);
            setPdfUrl(url);
        } else {
            alert("Please select a PDF file");
        }
    };

    const handleUpload = async () => {
        if (!file) return;

        const formData = new FormData();
        formData.append("pdf", file);

        try {
            await axios.post("http://localhost:5000/upload", formData);
            alert("อัปโหลดสำเร็จ");
        } catch (err) {
            console.error(err);
            alert("เกิดข้อผิดพลาดในการอัปโหลด");
        }
    };
    const handleDownload = (fileName) => {
        window.open(`/ptas/print?fileName=${encodeURIComponent(fileName)}`, '_blank');
    };
    return (
        <Box className='otherSide' id="otherSide" sx={{ backgroundColor: '#600537', }}>
            <Box className='surveyLayouts' id="surveyLayouts" align="center">
                <Card
                    sx={{
                        border: ' grey',
                        background: '#fafaeb',
                        width: '60%',
                    }}>
                    <CardContent align="center"
                        sx={{
                            border: '2px solid #1976d2', // สีกรอบ (ปรับได้ตามต้องการ)
                            borderRadius: '16px',        // มุมโค้ง
                            padding: 2,                  // ระยะห่างขอบใน
                            display: 'inline-block',     // ให้กรอบพอดีกับเนื้อหา
                            textAlign: 'center',         // จัดตำแหน่งให้อยู่กลาง
                            m: 2
                        }}
                    >
                        <Typography variant="h4" align="center" gutterBottom>
                            ระบบรับคำร้องภาษีที่ดินและสิ่งปลูกสร้างออนไลน์
                        </Typography>
                        <Typography variant="h4" align="center" gutterBottom>
                            แจ้งผ่าน Line Official Account
                        </Typography>
                        <Box
                            sx={{
                                border: '2px solid #1976d2', // สีกรอบ (ปรับได้ตามต้องการ)
                                borderRadius: '16px',        // มุมโค้ง
                                padding: 2,                  // ระยะห่างขอบใน
                                display: 'inline-block',     // ให้กรอบพอดีกับเนื้อหา
                                textAlign: 'center',         // จัดตำแหน่งให้อยู่กลาง
                                m: 2
                            }}
                        >
                            <Typography variant="h5" gutterBottom>
                                กองสารสนเทศภาษีและทะเบียนทรัพย์สิน
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center', // จัดให้ตรงกลาง
                                }}
                            >
                                <Button
                                    component="a"
                                    href="https://lin.ee/kTqSeLo" // ลิงก์ไปหน้า LINE OA
                                    target="_blank"
                                    sx={{
                                        padding: 0,
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        display: 'inline-block',
                                    }}
                                >
                                    <img
                                        src='./qrcode002.png'
                                        alt="LINE QR Code"
                                        style={{ width: 300, height: 300 }}
                                    />
                                </Button>
                                <Typography gutterBottom>
                                    สแกนคิวอาร์โค้ด หรือคลิ๊ก
                                </Typography>
                            </Box>
                            <Typography variant="h5" gutterBottom>
                                - แจ้งการเปลี่ยนแปลงการใช้ประโยชน์ที่ดินและสิ่งปลูกสร้าง(คำร้อง ภดส.5)
                            </Typography>
                            <Typography variant="h5" gutterBottom>
                                - เปลี่ยนแปลงป้าย(คำร้องทั่วไป)
                            </Typography>
                            <Typography variant="h5" gutterBottom>
                                - คัดสำเนารายการที่ดินและสิ่งปลูกสร้าง(คำร้องทั่วไป)
                            </Typography>
                            <Typography variant="h5" gutterBottom>
                                - ขอทบทวนการประเมินภาษีที่ดินและสิ่งปลูกสร้าง(คำร้องทั่วไป)
                            </Typography>
                            <Box sx={{ m: 2 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            sx={{ fontSize: '1.1rem', py: 1.5 }}
                                            onClick={() => handleDownload('pds5')}
                                        >
                                            📃 ดาวน์โหลดคำร้อง ภดส.5
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="warning"
                                            sx={{ fontSize: '1.1rem', py: 1.5 }}
                                            onClick={() => handleDownload('general1')}
                                        >
                                            📃 ดาวน์โหลดคำร้องทั่วไป
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            sx={{ fontSize: '1.1rem', py: 1.5 }}
                                            onClick={() => handleDownload('example_pds5')}
                                        >
                                            📃 ตัวอย่างคำร้อง ภดส.5
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="warning"
                                            sx={{ fontSize: '1.1rem', py: 1.5 }}
                                            onClick={() => handleDownload('example_general1')}
                                        >
                                            📃 ตัวอย่างคำร้องทั่วไป
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* <Button
                                variant="contained"
                                color="success"
                                sx={{ fontSize: '1.1rem', py: 1.5, ml: 1 }}
                            // onClick={() => {
                            //     handleDownload('billboard')
                            // }}
                            >
                                📃 หรือคลิ๊ก
                            </Button> */}
                        </Box>
                        <Box
                            sx={{
                                border: '2px solid #1976d2', // สีกรอบ (ปรับได้ตามต้องการ)
                                borderRadius: '16px',        // มุมโค้ง
                                padding: 2,                  // ระยะห่างขอบใน
                                display: 'inline-block',     // ให้กรอบพอดีกับเนื้อหา
                                textAlign: 'center',         // จัดตำแหน่งให้อยู่กลาง
                                m: 2
                            }}
                        >
                            <Typography variant="h5" gutterBottom>
                                ส่วนพัฒนารายได้ สำนักคลัง
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center', // จัดให้ตรงกลาง
                                }}
                            >
                                <Button
                                    component="a"
                                    href="https://lin.ee/ow9YNUQ" // ลิงก์ไปหน้า LINE OA
                                    target="_blank"
                                    sx={{
                                        padding: 0,
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        display: 'inline-block',
                                    }}
                                >
                                    <img
                                        src="./qrcode001.jpg"
                                        alt="LINE QR Code"
                                        style={{ width: 300, height: 300, display: 'block' }}
                                    />
                                </Button>
                                <Typography gutterBottom>
                                    สแกนคิวอาร์โค้ด หรือคลิ๊ก
                                </Typography>
                            </Box>
                            <Typography variant="h5" gutterBottom>
                                - คัดค้านการประเมินภาษีหรือเรียกเก็บภาษีที่ดินและสิ่งปลูกสร้าง(คำร้อง ภดส.10)
                            </Typography>
                            <Typography variant="h5" gutterBottom>
                                - แจ้งเปลี่ยนที่อยู่รับจดหมาย(แบบแสดงเจตจำนงแจ้งถิ่นที่อยู่)
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ fontSize: '1.1rem', py: 1.5, m: 1 }}
                                onClick={() => {
                                    handleDownload('pds10')
                                }}
                            >
                                📃 ดาวน์โหลดคำร้อง ภดส.10
                            </Button>
                            <Button
                                variant="contained"
                                color="warning"
                                sx={{ fontSize: '1.1rem', py: 1.5, m: 1 }}
                                onClick={() => {
                                    handleDownload('general2')
                                }}
                            >
                                📃 ดาวน์โหลดคำร้องทั่วไป
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ fontSize: '1.1rem', py: 1.5, m: 1 }}
                                onClick={() => {
                                    handleDownload('address_change')
                                }}
                            >
                                📃 แบบแสดงเจตจำนงแจ้งถิ่นที่อยู่
                            </Button>
                        </Box>
                    </CardContent>
                    {/* <CardContent>
                        <Typography variant="h5" align="center" gutterBottom>
                            หรือ
                        </Typography>
                        <Typography variant="h5" align="center" gutterBottom>
                            แจ้งผ่านเว็บ
                        </Typography>
                        <Typography variant="h5" align="center" gutterBottom>
                            ข้อมูลผู้เขียนคำร้อง
                        </Typography>
                        <TextField
                            label="ชื่อ"
                            sx={{ width: '300px', m: 1 }}
                            // value={code}
                            // onChange={(e) => {
                            //     setCode(e.target.value)
                            // }}
                            variant="outlined"
                        />
                        <TextField
                            label="นามสกุล"
                            sx={{ width: '300px', m: 1 }}
                            // value={code}
                            // onChange={(e) => {
                            //     setCode(e.target.value)
                            // }}
                            variant="outlined"
                        />
                        <TextField
                            label="เลขประจำตัวประชาชน"
                            sx={{ width: '300px', m: 1 }}
                            // value={code}
                            // onChange={(e) => {
                            //     setCode(e.target.value)
                            // }}
                            variant="outlined"
                        />
                        <TextField
                            label="หมายเลขโทรศัพท์"
                            sx={{ width: '300px', m: 1 }}
                            // value={code}
                            // onChange={(e) => {
                            //     setCode(e.target.value)
                            // }}
                            variant="outlined"
                        />
                        <TextField
                            label="E-mail"
                            sx={{ width: '300px', m: 1 }}
                            // value={code}
                            // onChange={(e) => {
                            //     setCode(e.target.value)
                            // }}
                            variant="outlined"
                        />
                        <Typography variant="h5" align="center" gutterBottom>
                            อัพโหลดเอกสาร
                        </Typography>
                        <input
                            accept="application/pdf"
                            type="file"
                            id="upload-pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                        <label htmlFor="upload-pdf">
                            <Button
                                variant="contained"
                                component="span"
                                sx={{ fontSize: '1.1rem', py: 1.5, ml: 1 }}
                            >
                                📄 เลือกไฟล์ PDF
                            </Button>
                        </label>
                        {pdfUrl && (
                            <iframe
                                src={pdfUrl}
                                width="100%"
                                height="1200px"
                                title="PDF Preview"
                                style={{ border: "1px solid #ccc", marginTop: 10 }}
                            />
                        )}
                    </CardContent> */}
                </Card>
            </Box>
        </Box >
    )
}
